import styled from 'styled-components';
import { animated as A } from 'react-spring';
import { size, typography, Icons, colors } from '@everlywell/leaves';

export const Wrapper = styled.div`
  padding-top: ${size.lg}px;
`;

export const CategoryLabel = styled.p`
  ${typography.bodyTextSmall};
  text-align: left;
`;

export const CategoryList = styled.ul`
  margin-top: ${size.sm}px;
  padding-left: ${size.lg}px;
  position: relative;
`;

export const AnimatedArrow = styled(A.div)`
  position: absolute;
  left: 9px;
`;

export const Arrow = styled(Icons.RightArrow)`
  width: 7px;
  height: 12px;
  color: ${colors.red2};
`;

export const CategoryItem = styled.li`
  list-style-type: none;
  text-align: left;
`;

export const Category = styled.button`
  cursor: pointer;
  background: none;
  padding: 0;
  border: none;
  ${typography.buttonTextSmall};
  font-size: 18px;
  margin-bottom: 18px;
`;
